'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3, _dec4, _class7, _class8, _temp4;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _IyvListMobileTable = require('./IyvListMobileTable.css');

var _IyvListMobileTable2 = _interopRequireDefault(_IyvListMobileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListMobileTable = (_dec = (0, _reactCssModules2.default)(_IyvListMobileTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListMobileTable, _Component);

  //
  function IyvListMobileTable(props) {
    (0, _classCallCheck3.default)(this, IyvListMobileTable);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListMobileTable.__proto__ || (0, _getPrototypeOf2.default)(IyvListMobileTable)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListMobileTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.IyvListMobileSort, {
          sort: this.props.sort,
          isDesc: this.props.isDesc,
          clickColumnHeader: this.props.clickColumnHeader,
          resultsTableColumns: this.props.resultsTableColumns
        }),
        this.props.funds.map(function (shareclass, idx) {
          return _react2.default.createElement(IyvListMobileTableRow, {
            key: 'IyvListMobileTableRow-' + idx,
            idx: idx,
            shareclass: shareclass,
            resultsTableColumns: _this2.props.resultsTableColumns,
            clickCompareSelect: _this2.props.clickCompareSelect,
            getCompareSelectStyles: _this2.props.getCompareSelectStyles,
            cart: _this2.props.cart,
            clickShareclass: _this2.props.clickShareclass,
            activeGrouping: _this2.props.activeGrouping
          });
        })
      );
    }
  }]);
  return IyvListMobileTable;
}(_react.Component), _class2.propTypes = {
  viewPanel: _react.PropTypes.string,
  funds: _react.PropTypes.array,
  sort: _react.PropTypes.string,
  isDesc: _react.PropTypes.bool,
  clickShareclass: _react.PropTypes.func,
  clickCompareSelect: _react.PropTypes.func,
  clickColumnHeader: _react.PropTypes.func,
  activeGrouping: _react.PropTypes.string,
  cart: _react.PropTypes.object,
  getCompareSelectStyles: _react.PropTypes.func,
  resultsTableColumns: _react.PropTypes.object
}, _temp)) || _class);
exports.default = IyvListMobileTable;
var IyvListMobileTableRow = (_dec2 = (0, _reactCssModules2.default)(_IyvListMobileTable2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvListMobileTableRow, _Component2);

  //
  function IyvListMobileTableRow(props) {
    (0, _classCallCheck3.default)(this, IyvListMobileTableRow);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (IyvListMobileTableRow.__proto__ || (0, _getPrototypeOf2.default)(IyvListMobileTableRow)).call(this, props));

    _this3.clickPanelButton = function (v) {
      var newState = {
        resultsShow: false,
        performanceShow: false,
        iyvShow: false
      };
      // if requested panel already showing, close them all
      if (!_this3.state[v + 'Show']) {
        newState[v + 'Show'] = true;
      }
      _this3.setState(newState);
    };

    var _props$shareclass = props.shareclass,
        ticker = _props$shareclass.ticker,
        fund_legal_name = _props$shareclass.fund_legal_name,
        fund_id = _props$shareclass.fund_id,
        investment_vehicle_id = _props$shareclass.investment_vehicle_id;

    // make ticker safe for URL

    var sTicker = ticker || 'N';

    var urlBuilder = function urlBuilder(route, profilePath) {
      return route + '/' + _format2.default.sanitize(fund_legal_name) + '/' + sTicker + '/' + profilePath + '/' + fund_id + '/' + investment_vehicle_id;
    };

    var url = urlBuilder(_config2.default.routes.fund, _config2.default.profilePath);

    var viewTabConfig = null;
    switch (_config2.default.app.title) {
      case 'Fossil Free Funds':
        viewTabConfig = [['results', 'Fossil fuels'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Deforestation Free Funds':
        viewTabConfig = [['results', 'Deforestation'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Weapon Free Funds':
        viewTabConfig = [['results', 'Military weapons'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Gun Free Funds':
        viewTabConfig = [['results', 'Civilian firearms'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Tobacco Free Funds':
        viewTabConfig = [['results', 'Tobacco'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Gender Equality Funds':
        viewTabConfig = [['results', 'Gender equality'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Prison Free Funds':
        viewTabConfig = [['results', 'Prison industrial complex'], ['performance', 'Performance'], ['iyv', 'Sustainability']];
        break;
      case 'Invest Your Values':
        viewTabConfig = [['results', 'Sustainability'], ['performance', 'Performance']];
        break;
      default:
        break;
    }

    _this3.state = {
      fundUrl: url,
      viewTabConfig: viewTabConfig,
      resultsShow: true,
      performanceShow: false,
      iyvShow: false
    };
    return _this3;
  }
  //


  (0, _createClass3.default)(IyvListMobileTableRow, [{
    key: 'render',

    //
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        {
          key: 'ilmt-' + this.props.idx,
          styleName: 'ilmt-row'
        },
        _react2.default.createElement(
          'h3',
          { styleName: 'ilmt-name' },
          this.props.shareclass.name
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'ilmt-ticker' },
          this.props.shareclass.ticker
        ),
        this.state.viewTabConfig.map(function (e, _i) {
          var panel = e[0];
          var label = e[1];
          return _react2.default.createElement(IyvListMobileTableRowSection, {
            key: 'IyvListMobileTableRowSection-' + _this4.props.idx + '-' + _i,
            shareclass: _this4.props.shareclass,
            panel: panel,
            label: label,
            resultsTableColumns: _this4.props.resultsTableColumns,
            showPanel: _this4.state[panel + 'Show'],
            panelLabel: label,
            clickPanelButton: _this4.clickPanelButton,
            clickShareclass: _this4.props.clickShareclass,
            activeGrouping: _this4.props.activeGrouping
          });
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'ilmt-compare' },
          _react2.default.createElement(
            _components.Link,
            {
              to: this.state.fundUrl,
              title: this.props.shareclass.name
            },
            _react2.default.createElement(
              'div',
              { styleName: 'ilmt-profile-link' },
              'Fund details',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return IyvListMobileTableRow;
}(_react.Component), _class4.propTypes = {
  idx: _react.PropTypes.number,
  shareclass: _react.PropTypes.object,
  resultsTableColumns: _react.PropTypes.object,
  clickCompareSelect: _react.PropTypes.func,
  getCompareSelectStyles: _react.PropTypes.func,
  cart: _react.PropTypes.object,
  clickShareclass: _react.PropTypes.func,
  activeGrouping: _react.PropTypes.string
}, _temp2)) || _class3);
var IyvListMobileTableRowSection = (_dec3 = (0, _reactCssModules2.default)(_IyvListMobileTable2.default, { allowMultiple: true }), _dec3(_class5 = (_temp3 = _class6 = function (_Component3) {
  (0, _inherits3.default)(IyvListMobileTableRowSection, _Component3);

  //
  function IyvListMobileTableRowSection(props) {
    (0, _classCallCheck3.default)(this, IyvListMobileTableRowSection);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (IyvListMobileTableRowSection.__proto__ || (0, _getPrototypeOf2.default)(IyvListMobileTableRowSection)).call(this, props));

    _this5.state = {
      cols: _this5.props.resultsTableColumns[_config2.default.app.title][_this5.props.panel]
    };
    return _this5;
  }
  //


  (0, _createClass3.default)(IyvListMobileTableRowSection, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          {
            styleName: 'ilmt-panel-btn',
            onClick: function onClick() {
              _this6.props.clickPanelButton(_this6.props.panel);
            }
          },
          _react2.default.createElement(
            'div',
            null,
            this.props.panel === 'results' ? this.props.panelLabel : this.props.label
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: this.props.showPanel ? 'fa-angle-up' : 'fa-angle-down' })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          /* for each column */
          this.props.showPanel ? _react2.default.createElement(
            'table',
            { styleName: 'ilmt-data-panel-table' },
            _react2.default.createElement(
              'tbody',
              { styleName: 'ilmt-data-panel' },
              this.state.cols.slice(1, this.state.cols.length).map(function (column, i) {
                // [label, prop] = column
                return _react2.default.createElement(
                  'tr',
                  {
                    styleName: 'ilmt-data-panel-row',
                    key: 'ilmt-data-panel-row-' + i
                  },
                  _react2.default.createElement(
                    'td',
                    null,
                    column[0]
                  ),
                  _react2.default.createElement(IyvListMobileTd, {
                    shareclass: _this6.props.shareclass,
                    fieldName: column[1],
                    clickShareclass: _this6.props.clickShareclass,
                    activeGrouping: _this6.props.activeGrouping
                  })
                );
              })
            )
          ) : null
        )
      );
    }
  }]);
  return IyvListMobileTableRowSection;
}(_react.Component), _class6.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  panel: _react.PropTypes.string,
  label: _react.PropTypes.string,
  resultsTableColumns: _react.PropTypes.object,
  showPanel: _react.PropTypes.bool,
  panelLabel: _react.PropTypes.string,
  clickPanelButton: _react.PropTypes.func,
  clickShareclass: _react.PropTypes.func,
  activeGrouping: _react.PropTypes.string
}, _temp3)) || _class5);
var IyvListMobileTd = (_dec4 = (0, _reactCssModules2.default)(_IyvListMobileTable2.default, { allowMultiple: true }), _dec4(_class7 = (_temp4 = _class8 = function (_Component4) {
  (0, _inherits3.default)(IyvListMobileTd, _Component4);

  //
  function IyvListMobileTd(props) {
    (0, _classCallCheck3.default)(this, IyvListMobileTd);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListMobileTd.__proto__ || (0, _getPrototypeOf2.default)(IyvListMobileTd)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListMobileTd, [{
    key: 'render',
    value: function render() {
      //
      if (['fund_net_assets'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdNetAssets, {
          shareclass: this.props.shareclass,
          mobile: true
        });
      }

      if (['ussif'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdSriUssif, {
          shareclass: this.props.shareclass,
          mobile: true
        });
      }

      if (['prospectus_net_expense_ratio', 'trailing_return_y1', 'trailing_return_y3', 'trailing_return_y5', 'trailing_return_y10', 'trailing_return_y15', 'trailing_return_y20'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdReturns, {
          shareclass: this.props.shareclass,
          fieldName: this.props.fieldName,
          mobile: true
        });
      }

      if (['morningstar_category_name', 'category_group'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGroupCategory, {
          shareclass: this.props.shareclass,
          mobile: true
        });
      }

      if (['gm_weight', 'gr_weight', 'wff_civ_weight', 'pff_all_extreme_weight', 'pff_all_high_weight', 'pp_high_weight', 'borders_high_weight', 'pff_all_weight', 'cl_weight', 'po_producer_weight', 'po_financier_weight', 'po_consumer_weight', 'po_all_weight', 'mmc_weight', 'cm_weight', 'nw_weight', 'wff_mil_weight', 'to_weight', 'tm_weight', 't_all_weight'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdPercent, {
          shareclass: this.props.shareclass,
          fieldName: this.props.fieldName,
          mobile: true
        });
      }

      if (['fossil_bank_score', 'fossil_insure_score'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdFossilFinanceGrade, {
          shareclass: this.props.shareclass,
          fieldName: this.props.fieldName,
          clickShareclass: this.props.clickShareclass,
          mobile: true
        });
      }

      if (['grade_guns', 'grade_prison_industrial_complex', 'grade_fossil', 'grade_deforestation', 'grade_gender_equality', 'grade_military', 'grade_tobacco'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGrade, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          fieldName: this.props.fieldName
        });
      }

      if (['gef_score'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGenderEqualityScore, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      if (['gef_grp_norm'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdGenderEqualityRank, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass,
          activeGrouping: this.props.activeGrouping
        });
      }

      if (['c2f5coogutweight'].includes(this.props.fieldName)) {
        return _react2.default.createElement(_components.IyvListTdFossilGrade, {
          shareclass: this.props.shareclass,
          clickShareclass: this.props.clickShareclass
        });
      }

      return _react2.default.createElement(_components.IyvListTdDefault, {
        shareclass: this.props.shareclass,
        fieldName: this.props.fieldName,
        mobile: true
      });
    }
  }]);
  return IyvListMobileTd;
}(_react.Component), _class8.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  fieldName: _react.PropTypes.string.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired,
  activeGrouping: _react.PropTypes.string
}, _temp4)) || _class7);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListMobileTable/IyvListMobileTable.js
// module id = 1446
// module chunks = 0